import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";
import ScheduleAppointment from "@/pages/ScheduleAppointment";

export const Route = createFileRoute("/schedule-appointment")({
  head: () => pageHead({
    title: 'Schedule a Service Appointment',
    description: 'Book RV service online with Rex & Sons RVs in Castle Hayne, NC — certified technicians for repairs, maintenance and installs.',
    path: '/schedule-appointment',
  }),
  component: ScheduleAppointment,
});
